import React, { useState, useEffect } from "react";
import axios from "axios";
import { t } from "../../localization/localization";
import { Row } from "react-bootstrap";

const SemanticScholarRecommendationTable = () => {
  const [reccomendationData, setRecommendationData] = useState();
  const urlSearchParams = new URLSearchParams(window.location.search);
  const locale = urlSearchParams.get("locale") ?? "tr";
  const firstId = window.location.pathname.split("/")[3];
  const secondId = window.location.pathname.split("/")[4];

  useEffect(() => {
    axios
      .get(
        `${window._env_.BASE_URL}/gcris-api/publication/external-metrics/semantic-scholar/related-papers`,
        {
          params: {
            handle: `${firstId}/${secondId}`,
          },
        }
      )
      .then((res) => {
        setRecommendationData(res?.data);
      });
  }, []);

  if (reccomendationData) {
    return (
      <div className="container-fluid overflow-hidden">
        <div className="container-fluid ">
          <h3>
            {t(
              locale,
              "/charts/handle/semantic-scholar/recommendation/semanticScholarRecommendations"
            )}
          </h3>
        </div>
        <div className="card">
          <div className="card-header">
            <ul class="nav nav-tabs card-header-tabs">
              <li class="nav-item">
                <a class="nav-link active" href="#">
                  Semantic Scholar
                </a>
              </li>
            </ul>
          </div>
          <div className="vh-100 overflow-auto">
            {reccomendationData.map((rec) => (
              <RecommendationCard
                locale={locale}
                url={rec.url}
                year={rec.year}
                authors={rec.authors}
                title={rec.title}
                citationCount={rec.citationCount}
              />
            ))}
          </div>
        </div>
      </div>
    );
  } else {
    return <div></div>;
  }
};

export default SemanticScholarRecommendationTable;

const RecommendationCard = ({
  title,
  url,
  year,
  authors,
  citationCount,
  locale,
}) => {
  const [sideBarOpen, setSideBarOpen] = useState(false);

  return (
    <div className="container-fluid ">
      <div className="row ">
        <div className="col-12 mt-3">
          <div className="card">
            <a target="_blank" href={url}>
              <div
                className="card-horizontal"
                style={{ display: "flex", flex: "1 1 auto" }}
              >
                <div style={{ padding: "8px 16px", fontSize: "10px" }}>
                  <h4
                    style={{
                      fontSize: "10px",
                      fontWeight: "bold",
                      color: "#337ab7",
                    }}
                  >
                    {title}
                  </h4>

                  <p
                    style={{
                      margin: 0,
                      display: "inline",
                      fontSize: "12px",
                      fontWeight: "600",
                      color: "#e65e11",
                    }}
                  >
                    {t(
                      locale,
                      "/charts/handle/semantic-scholar/recommendation/year"
                    )}
                    :
                  </p>
                  <p
                    style={{
                      display: "inline",
                      fontSize: "12px",
                      fontWeight: "600",
                      color: "#337ab7",
                    }}
                  >
                    {" " + year}
                  </p>
                  <br />
                  <p
                    style={{
                      margin: 0,
                      display: "inline",
                      color: "#e65e11",
                      fontSize: "12px",
                      fontWeight: "600",
                    }}
                  >
                    {t(
                      locale,
                      "/charts/handle/semantic-scholar/recommendation/citationCount"
                    )}
                    :
                  </p>
                  <p
                    style={{
                      display: "inline",
                      fontSize: "12px",
                      fontWeight: "600",
                      color: "#337ab7",
                    }}
                  >
                    {" " + citationCount}
                  </p>
                  <br />
                  <p
                    style={{
                      margin: 0,
                      display: "inline",
                      color: "#e65e11",
                      fontSize: "12px",
                      fontWeight: "600",
                    }}
                  >
                    {t(
                      locale,
                      "/charts/handle/semantic-scholar/recommendation/by"
                    )}
                    :{" "}
                  </p>
                  <p
                    style={{
                      display: "inline",
                      color: "#337ab7",
                      fontSize: "14px",
                    }}
                  >
                    {authors.map((author) => (
                      <span
                        style={{
                          display: "inline",
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#337ab7",
                        }}
                      >
                        {author.name},{" "}
                      </span>
                    ))}
                  </p>
                </div>
                {sideBarOpen && <div className="h-full pr-1 bg-warning"></div>}
              </div>
            </a>
            <div className="card-footer">
              <small className="text-muted">Last updated 3 mins ago</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
